import React, { useMemo } from "react";

import MainItemsList from "features/itemLists/MainListView/MainItemsList";
import { connect } from "react-redux";
import { getActItems } from "shared/itemLists/redux/selectors/getActItems";

function ActItemsContainer(props) {
  function setActItems(provided) {
    console.log("provided", provided);
  }

  return (
    <MainItemsList
      {...props}
      listType="Act"
      mainItems={props.actItems}
      setMainItems={setActItems}
    />
  );
}

function mapStateToProps(state) {
  return {
    actItems: getActItems(state.itemLists),
  };
}

export default connect(mapStateToProps)(ActItemsContainer);
